import type { VoidFunctionComponent } from 'react';
import TextInput from '../../generic/Forms/TextInput';

type LabelTextInputProps = {
  value: string;
  onChange: (value: string) => void;
};

export const LabelTextInput: VoidFunctionComponent<LabelTextInputProps> = ({ value, onChange }) => {
  const maxSize = 50;
  return (
    <TextInput
      size="small"
      value={value}
      label="change label value"
      placeholder="Enter a unique label..."
      maxLength={maxSize}
      suffix={`${value.length}/${maxSize}`}
      onChange={onChange}
    />
  );
};
